
const state = function () {
  return {
    classCode: '',
    verifying: false,
    sessions: null,
    class: null,
    studentEntry: false,
    signupComplete: false,
    selectedSession: [],
    student: initialStudent(),
    initialStudent: initialStudent()
  }
}

function initialStudent () {
  return {
      dl: "",
      dl_state: 1,
      lastName: '',
      firstName: '',
      middleName: '',
      address1: '',
      city:'',
      state:  1,
      zip: '',
      gender: 0,
      dob: null, 
      phone: '',
      email: ''
  }    
}

export default {
  ...state()
}

export const initialState = state()
